const Music = () => (
  <h1>Music</h1>
);

export default Music;
